import { Application } from '@/types/application';
import { isApplication } from './typeGuards';

export const handleFileChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  callback: (app: Application) => void,
  callbackError: (error: Error) => void
) => {
  if (!event.target.files) return;
  const file = event.target.files[0];
  const reader = new FileReader();

  reader.onload = async (e) => {
    const text = e.target?.result as string;
    try {
      const json = JSON.parse(text);
      if (isApplication(json)) {
        callback(json);
      } else {
        callbackError(new Error('JSON file is not an application.'));
      }
    } catch (err) {
      if (err instanceof Error) {
        callbackError(err);
      }
      console.error('Could not parse JSON file:', err);
    }
  };
  reader.readAsText(file);
};
